import React, { useContext } from "react";
import formatCurrency from "../../func/currency_formatter";
import { TemplateContext } from "../../layout";
import TagIcon from "../../utils/images/tagIcon";
import { motion } from "framer-motion";
import DiscountTagBlock from "../DiscountTagBlock.jsx";

const ProductCardVariant = ({ product, index, type, variant }) => {
  const [templateContext, setTempalateContext] = useContext(TemplateContext);
  const warrantyLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_warrantyLabel;
  const discountAppliedLabel = window.post_template?.checkout_v4_summary?.tr_checkout_v4_discountApplied;
  const warrantyPrice = templateContext?.config?.warrantyState
    ? templateContext.config?.product.warranty_price * templateContext.config?.product.amount
    : 0.0;

  const colorsData = window.productData?.product_color_variants;

  const variantObject = colorsData?.find((item) => {
    return item.value == variant.color;
  });

  const image = variantObject?.variant_image ? variantObject?.variant_image : product?.image?.url;

  const productPriceBlock = () => {
    let price;
    if (templateContext.discountsEnabled && !templateContext.discountCode) {
      price = product.old_price;
    } else {
      price = product.price * product.amount;
    }
    if (templateContext.config.warrantyState) price = Number(price) + Number(warrantyPrice);
    let formattedPrice;
    let formattedOldPrice;

    if (templateContext.priceWithCents) {
      formattedPrice = product.formatted_price
        ? window.formattedString.replace(/(0\.00|0,00|0)/, Number((price / product.amount) * variant.amount).toFixed(2))
        : formatCurrency(product.price);
      formattedOldPrice = window.formattedString
        ? window.formattedString.replace(
            /(0\.00|0,00|0)/,
            Number(((Number(product.old_price) + warrantyPrice) / product.amount) * variant.amount).toFixed(2)
          )
        : formatCurrency(old_Price);
    } else {
      formattedPrice = product.formatted_price
        ? window.formattedString.replace(/(0\.00|0,00|0)/, Number((price / product.amount) * variant.amount))
        : formatCurrency(product.price);
      formattedOldPrice = window.formattedString
        ? window.formattedString.replace(
            /(0\.00|0,00|0)/,
            Number(((Number(product.old_price) + warrantyPrice) / product.amount) * variant.amount)
          )
        : formatCurrency(old_Price);
    }

    return (
      <div className="productCard__priceBlock">
        {templateContext.discountsEnabled && templateContext.discountCode === undefined ? (
          ""
        ) : (
          <span className="productCard__priceBlock__oldPrice">{formattedOldPrice}</span>
        )}
        <span className="productCard__priceBlock__price">{formattedPrice}</span>
      </div>
    );
  };

  return (
    <div key={index} className="productCard">
      <div className="productCard__imageContainer">
        <motion.div
          key={image}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 1,
            default: { duration: 0.5 },
          }}
        >
          <img src={image} alt={general_settings.brand_name} />
        </motion.div>

        <span className="productCard__imageContainer__indicator">{variant.amount}</span>
      </div>
      <div className="productCard__titleBlock">
        <div className="productCard__titleBlock__title">
          {product.display_name}{" "}
          {type !== "fake" && templateContext.config.warrantyState && <span>{warrantyLabel}</span>}
        </div>
        <p className="productCard__titleBlock__variant">
          <span>{variant.sizeLabel}</span> {variant.color && variant.size ? "/" : ""} <span>{variant.colorLabel}</span>
        </p>

        {window?.post_template?.checkout_v4_products?.checkout_v4_products_discountAppliedToggle && (
          <DiscountTagBlock discountAppliedLabel={discountAppliedLabel} />
        )}
        {product.tr_additional_texts && (
          <div className="productCard__titleBlock__altText">{product.tr_additional_texts}</div>
        )}

        {templateContext?.discountCode && (
          <div className="productCard__titleBlock__tagText">
            <TagIcon />
            {templateContext.discountCode} {`(-${formatCurrency(product.price)})`}
          </div>
        )}
      </div>
      {productPriceBlock()}
    </div>
  );
};
export default ProductCardVariant;
